import React, { FC, ReactElement, ReactNode } from 'react';
import { Card, CardBody, CardHeader, CardTitle, Col } from 'reactstrap';
import { TranslationKey, useTranslation } from '../translations';
import { LinkButton } from './LinkButton';
import { MaterialIcon } from './MaterialIcon';

interface InfoCardProps {
  readonly className?: string;
  readonly heading: TranslationKey | ReactElement;
  readonly text: (number | string)[] | number | string;
  readonly id?: string;
  readonly icon?: string;
  readonly largeText?: boolean;
  readonly status?: 'danger' | 'info' | 'success' | 'warning';
  readonly button?: {
    readonly status?: 'primary' | 'danger' | 'info' | 'success' | 'warning';
    readonly to: string;
    readonly text: TranslationKey;
    readonly outline?: boolean;
  };
}

export const InfoCard: FC<InfoCardProps> = ({
  className,
  status,
  id,
  heading,
  icon,
  button,
  text,
  largeText,
}) => {
  const { ts } = useTranslation();
  let renderedText: ReactNode = (Array.isArray(text) ? text : ['', text]).map((s) => (
    <p key={s}>{s}</p>
  ));

  if (!largeText) {
    renderedText = <small>{renderedText}</small>;
  }

  return (
    <Col className={className} lg={4} md={6} xs={12}>
      <Card className="info-card h-100" id={id}>
        <CardHeader className={`card-color ${status!}`} />
        <CardBody className="text-center">
          {icon && <MaterialIcon medium name={icon} />}
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          <h4>{React.isValidElement<any>(heading) ? heading : ts(heading)}</h4>
          {renderedText}
        </CardBody>
        {button && (
          <CardHeader>
            <CardTitle tag="h3">
              <LinkButton block color={button.status ?? ''} outline={button.outline} to={button.to}>
                {ts(button.text)}
              </LinkButton>
            </CardTitle>
          </CardHeader>
        )}
      </Card>
    </Col>
  );
};
